import api from './api';

// Public endpoint — no auth token required.
// type is one of 'privacy_policy' | 'terms_of_service'.
export async function getLegalDocument(type) {
  const response = await api.get(`/legal/${type}`);
  return response.data;
}

// Admin endpoint — creates or updates a legal document. Requires auth.
// payload: { title, content }
export async function updateLegalDocument(type, payload) {
  const response = await api.put(`/admin/legal/${type}`, payload);
  return response.data;
}
